import { createSelector } from 'reselect'
import _ from 'lodash';

export const tenantsList = (state) => state.tenants.tenants;




// WEBPACK FOOTER //
// ./src/storeState/tenants/selectors.js